import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from "react";

export interface ProductStripCardProps
  extends Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {
  variant: "primary" | "light";
  title?: string | null;
  description?: string | null;
  cta?: ReactNode | null;
}

export const ProductStripCard: FC<ProductStripCardProps> = ({
  variant,
  className,
  description,
  title,
  cta,
}) => {
  return (
    <div
      className={clsx([
        "px-3 py-4 lg:px-6 lg:py-7",
        "rounded-3xl overflow-hidden flex flex-col gap-2 lg:gap-4 items-stretch",
        variant === "primary" && "bg-primary text-light",
        variant === "light" && "bg-light text-dark",
        className,
      ])}
    >
      <div className="flex items-center gap-2 justify-between">
        {title && (
          <div
            className={clsx(
              "font-medium text-xl lg:text-2xl leading-tight",
              variant === "primary" && "text-light",
              variant === "light" && "text-primary"
            )}
          >
            {title}
          </div>
        )}
        {cta}
      </div>
      {description && <div className="font-light text-xs lg:text-base">{description}</div>}
    </div>
  );
};
